import { createSlice } from '@reduxjs/toolkit';

type AirMasterState = {
  filterSearchData: any;
  filterSearchTotal: number;
  hasMore: boolean;
  loading: boolean;
};

const initialState: AirMasterState = {
  filterSearchData: [],
  filterSearchTotal: 0,
  hasMore: false,
  loading: false,
};

export const airMasterSlice = createSlice({
  name: 'airMaster',
  initialState,
  reducers: {
    filterShip: (state, action) => {
      state.filterSearchData = [];
      state.hasMore = false;
      state.loading = true;
    },
    filterShipSuccess: (state, action) => {
      state.filterSearchData = action.payload.data;
      state.filterSearchTotal = action.payload.total;
      state.hasMore = action.payload.has_more;
      state.loading = false;
    },
    updateShip: (state, action) => {
      state.loading = true;
    },
    updateShipSuccess: (state, action) => {
      state.loading = false;
    },
    uploadShipMove: (state, action) => {},
    uploadShipMoveSuccess: (state, action) => {},
  },
});

export const { filterShip, filterShipSuccess, updateShip, updateShipSuccess, uploadShipMove, uploadShipMoveSuccess } =
  airMasterSlice.actions;

export default airMasterSlice.reducer;
